import {
  Button,
  CloseButton,
  IconCheckLine,
  Popover,
  Spinner,
  TextArea,
  View,
} from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { ExternalService } from "../../../../services/ExternalService";
import {
  ERROR,
  useNotification,
} from "../../../CustomHooks/NotificationProvider";

const ApproverNotes = ({
  context,
  uuid,
  noteObj,
  btnLabel,
  isApproved,
  handleApprove,
  handleUpdate,
  disabled,
}) => {
  const { t } = useTranslation();
  const showNotification = useNotification();
  const [openPopover, setOpenPopover] = useState(false);
  const [approverNote, setApproverNote] = useState(noteObj?.note || "");
  const [approving, setApproving] = useState(false);

  const handleSaveApproverNote = async () => {
    try {
      setApproving(true);
      const approvePromise =
        context === "plan"
          ? ExternalService.approveAssessmentPlanResults(uuid, approverNote)
          : ExternalService.approveSectionResults(uuid, approverNote);

      await approvePromise;
      handleApprove(uuid, approverNote);
      setOpenPopover(false);
      showNotification(
        t("notifications.assessmentResults.addApprovalNotesSuccess")
      );
    } catch {
      showNotification(
        t("notifications.assessmentResults.addApprovalNotesError"),
        ERROR
      );
    } finally {
      setApproving(false);
    }
  };

  const handleUpdateApproverNote = async () => {
    try {
      setApproving(true);
      await ExternalService.updateApprovalNote(noteObj.ddl_id, approverNote);
      handleUpdate(uuid, approverNote);
      setOpenPopover(false);
      showNotification(
        t("notifications.assessmentResults.addApprovalNotesSuccess")
      );
    } catch {
      showNotification(
        t("notifications.assessmentResults.addApprovalNotesError"),
        ERROR
      );
    } finally {
      setApproving(false);
    }
  };

  return (
    <Popover
      isShowingContent={openPopover}
      onShowContent={() => setOpenPopover(true)}
      onHideContent={() => setOpenPopover(false)}
      renderTrigger={
        <Button
          color="primary"
          size="small"
          interaction={disabled ? "disabled" : "enabled"}
        >
          {btnLabel}
        </Button>
      }
      on="click"
      placement="bottom"
    >
      <View width={500} display="block" padding="small">
        <CloseButton
          placement="end"
          onClick={() => setOpenPopover(false)}
          screenReaderLabel={t("global.close")}
        />

        <TextArea
          label={t("results.approverNotes")}
          resize="vertical"
          height="100px"
          value={approverNote}
          onChange={(e) => setApproverNote(e.target.value)}
        />
        <Button
          size="small"
          color="primary"
          margin="small 0 0 0"
          onClick={
            isApproved ? handleUpdateApproverNote : handleSaveApproverNote
          }
          renderIcon={
            approving ? (
              <Spinner renderTitle={t("global.pleaseWait")} size="x-small" />
            ) : (
              IconCheckLine
            )
          }
          disabled={approving}
        >
          {t("analyze.approve")}
        </Button>
      </View>
    </Popover>
  );
};

export default ApproverNotes;
